// extracted by mini-css-extract-plugin
export default {"ripple":"Ripple_ripple__N1lXi","ripple-effect":"Ripple_ripple-effect__SBWPW"};